<template>
  <v-row>
    <v-file-input
        v-model="file"
        :label="label"
        accept="audio/*"
        @change="$emit('change', file)"
    ></v-file-input>
    <v-icon large color="accent" :disabled="!this.file" @click="play">mdi-play</v-icon>
  </v-row>
</template>

<script>
export default {
  name: "UploadSoundfile",
  props: {
    label: String,
  },
  data: () => ({
    file: null,
    playing: false,
  }),

  methods: {
    play() {
      if (this.playing || !this.file) return;
      const url = URL.createObjectURL(this.file);
      const audio = new Audio(url);
      this.playing = true;
      audio.play();
      const that = this;
      audio.addEventListener("ended", () => that.playing = false);
    },

    clear() {
      this.file = null;
    }
  }
}
</script>

<style scoped>
/*.v-icon{
  cursor: pointer;
}*/
</style>
